import React from 'react';

export default function StuffSide() {
  return null;
}
